import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Switch,
  Button,
  Paper,
  useTheme,
} from "@mui/material";
import Header from "../../../Dashboard/Header";
import { tokens } from "../../../../theme";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

export default function StockItemConfig() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const cmpid = localStorage.getItem("cmpid");

  const [users, setUsers] = useState([]);
  const [configList, setConfigList] = useState([]);

  /* helper – turn anything into a real array */
  const toArray = (payload) =>
    Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.users)
      ? payload.users
      : Object.values(payload?.users || payload || {});

  /* ────────────────────────────────────────────
     FETCH AND MERGE
  ───────────────────────────────────────────── */
  useEffect(() => {
    const fetchAll = async () => {
      try {
        /* 1) users */
        const { data: userRaw } = await axios.post(
          `${process.env.REACT_APP_API_URL}/userAPI/list`,
          {},
          { headers: { Authorization: token } }
        );
        const userArr = toArray(userRaw);

        /* 2) configs */
        const { data: cfgRaw } = await axios.post(
          `${process.env.REACT_APP_API_URL}/approvalModule/userconfig/list`,
          { cmpid, type: "stockitem" },
          { headers: { Authorization: token } }
        );
        // console.log("Config list (raw):", cfgRaw);
        const cfgArr = toArray(cfgRaw);

        /* 3) merge */
        const merged = userArr.map((u) => {
          const uid = u.user_Id ?? u.user_id ?? u.userid;
          const match = cfgArr.find(
            (c) =>
              (c.user_Id ?? c.user_id) === uid && c.type_name === "stockitem"
          );
          return {
            user_Name: u.user_Name ?? u.user_name,
            user_Id: uid,
            firstLevel: match?.permission_Level_1 === "1" || false,
          };
        });

        setUsers(userArr);
        setConfigList(merged);
      } catch (err) {
        console.error(err);
      }
    };

    fetchAll();
  }, [cmpid, token]);

  /* ────────────────────────────────────────────
     TOGGLE ONE USER
  ───────────────────────────────────────────── */
  const handleToggle = (userId) => {
    setConfigList((prev) => {
      const updated = prev.map((u) =>
        u.user_Id === userId ? { ...u, firstLevel: !u.firstLevel } : u
      );

      const { firstLevel: newVal } = updated.find((u) => u.user_Id === userId);

      (async () => {
        try {
          await axios.post(
            `${process.env.REACT_APP_API_URL}/approvalModule/userconfig/create`,
            [
              {
                userid: userId,
                permissionLevel1: newVal ? 1 : 0,
                cmpid,
                type: "stockitem",
                Typename: "stockitem",
              },
            ],
            { headers: { Authorization: token } }
          );
        } catch (err) {
          console.error(err);
          /* rollback local flip */
          setConfigList((rb) =>
            rb.map((u) =>
              u.user_Id === userId ? { ...u, firstLevel: !newVal } : u
            )
          );
          Swal.fire("Error!", "Could not update this user.", "error");
        }
      })();

      return updated;
    });
  };

  /* ────────────────────────────────────────────
     RENDER
  ───────────────────────────────────────────── */
  return (
    <Box mt="70px" ml="0px" mr="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header
          title="Stock Item"
          subtitle="Approval Stock Item Configurations"
        />
        <Button variant="contained"
        sx={{
          height:28,
        }}
        onClick={() => navigate(-1)}
        >Back</Button>
      </Box>

      <Paper elevation={3} sx={{ p: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>User Name</TableCell>
              <TableCell>Stock Item Enable</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {configList.length ? (
              configList.map((u) => (
                <TableRow key={u.user_Id}>
                  <TableCell>{u.user_Name}</TableCell>
                  <TableCell>
                    <Switch
                      checked={u.firstLevel}
                      onChange={() => handleToggle(u.user_Id)}
                      color="success"
                    />
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow key="no-data">
                <TableCell colSpan={2}>No data found</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button
            variant="contained"
            color="success"
            onClick={() =>
              Swal.fire({
                title: "success!",
                text: "Approval Users Configuration Submitted Successfully",
                icon: "success",
                confirmButtonText: "OK",
                confirmButtonColor: "#28a745",
                width: "300px",
                padding: "1em",
                customClass: {
                  popup: "small-alert",
                },
              }).then((result) => {
                if (result.isConfirmed) {
                  navigate("/Infinite/ApprovalModuleUsers");
                }
              })
            }
          >
            Save
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
